import { render, staticRenderFns } from "./ButtonCard.vue?vue&type=template&id=ec9bce38&scoped=true&"
import script from "./ButtonCard.vue?vue&type=script&lang=js&"
export * from "./ButtonCard.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCard.vue?vue&type=style&index=0&id=ec9bce38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9bce38",
  null
  
)

export default component.exports